<template>
  <div class="flash-messages position-fixed">
    <transition name="slide" duration="300">
      <Message v-if="message" :message="message" />
    </transition>
  </div>
</template>

<script>
import { useFlashMessengerStore } from '@/stores/flashMessenger'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'
const Message = defineAsyncComponent(
  () => import('@/components/basic/molecules/Message.vue')
)
export default {
  components: { Message },
  computed: {
    ...mapState(useFlashMessengerStore, ['message'])
  }
}
</script>

<style scoped>
.flash-messages {
  top: 0;
  right: 0;
  left: 0;
  z-index: 10;
}
.slide-enter-active,
.slide-leave-active {
  transition: all var(--transition-duration-l);
}
.slide-enter, .slide-leave-to /* .list-leave-active below version 2.1.8 */ {
  transform: translateY(-100%);
}
.display-sm-and-up .flash-messages {
  top: 95px;
  left: auto;
}

.display-sm-and-up .slide-enter, .slide-leave-to /* .list-leave-active below version 2.1.8 */ {
  transform: translateX(100%);
}
</style>
